import { fetchDocumentsThunk } from "./documentOperations";

const { createSlice, createEntityAdapter } = require("@reduxjs/toolkit");

const entityAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const slice = createSlice({
  name: "documents",
  initialState: {
    textSearch: "",
    isLoading: false,
    ...entityAdapter.getInitialState(),
  },
  reducers: {
    setTextSearch(state, action) {
      state.textSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDocumentsThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDocumentsThunk.fulfilled, (state, action) => {
      entityAdapter.setAll(state, action.payload);
      state.isLoading = false;
    });
    builder.addCase(fetchDocumentsThunk.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

const selectSelf = (state) => state.documents.documents;

export const documentSelectors = {
  selectTextSearch: (state) => selectSelf(state).textSearch,
  ...entityAdapter.getSelectors((state) => state.documents.documents),
};

export const documentActions = slice.actions;

export const reducer = slice.reducer;
